module.exports = {
      id: "share-menu-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#share-menu",
      toString: function () {
        return this.url;
      }
    }